import React from 'react';

const ServerError = ({ message }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="text-center max-w-md">
                <div className="mb-8">
                    <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg className="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                        </svg>
                    </div>
                    <h1 className="text-6xl font-bold text-gray-800 mb-4">500</h1>
                    <div className="text-3xl font-semibold text-gray-800 mb-4">Server Error</div>
                </div>
                
                <p className="text-lg text-gray-600 mb-2">
                    Oops! Something went wrong on our end.
                </p>
                
                {message && (
                    <p className="text-sm text-red-600 mb-6 p-3 bg-red-50 rounded-md border border-red-200">
                        {message}
                    </p>
                )}
                
                <div className="space-x-4">
                    <button
                        onClick={() => window.location.reload()}
                        className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-md transition-colors shadow-sm"
                    >
                        Try Again
                    </button>
                    <a
                        href="/"
                        className="inline-block bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-8 rounded-md transition-colors shadow-sm"
                    >
                        Go Home
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ServerError;
